import { AnimatedLoading, Wrapper } from '@/scenes/Gallery/Loading/styles';

interface GalleryLoadingProps {
  small?: boolean;
}

const GalleryLoading = ({ small = false }: GalleryLoadingProps) => {
  return (
    <AnimatedLoading small={small}>
      <Wrapper>
        <svg
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="27.3086"
            y="-4.31586"
            width="32"
            height="31"
            transform="rotate(66.2661 27.3086 -4.31586)"
            fill="#FADC4B"
          />
          <path
            d="M20.728 31.3354C19.0813 31.0691 17.9564 29.6092 17.9564 29.6092C17.5908 28.1692 19.0989 26.8669 21.5244 26.3934C23.9495 25.9198 26.5138 27.0149 26.8304 28.6324C27.1464 30.2501 22.3747 31.6017 20.728 31.3354ZM23.1394 22.8836C23.1378 21.1266 25.3179 19.6932 28.2586 19.425C31.0868 19.1665 33.537 20.6035 33.5386 22.3604C33.5403 24.1176 30.626 25.6708 27.786 25.6723C24.9459 25.6736 23.141 24.6405 23.1394 22.8836ZM14.2571 27.3928C12.1596 28.1138 10.1332 27.537 9.96825 24.0443C9.84664 21.4804 10.9327 21.2044 11.0137 19.558C11.0911 17.9857 8.55905 15.8058 9.7865 12.6488C11.0141 9.49199 14.6154 11.7334 16.4969 13.7247C18.3785 15.716 22.7891 16.5954 23.0993 18.6736C23.4094 20.7517 20.3947 21.6745 19.0996 22.8477C17.8047 24.0213 16.3549 26.6719 14.2571 27.3928ZM19.141 6.92538C20.7326 6.42675 25.6493 7.08359 25.5681 8.72975C25.4872 10.3758 23.1063 11.8253 20.6379 11.7028C18.1696 11.5803 16.4905 10.5066 16.6457 9.02905C16.6457 9.02905 17.5494 7.42364 19.141 6.92538ZM27.8611 11.5645C30.7008 11.5631 33.0044 12.9862 33.0063 14.743C33.0081 16.4998 30.7072 17.9254 27.8672 17.9269C25.0273 17.9287 22.7236 16.5054 22.7218 14.7486C22.7202 12.9917 25.0211 11.5661 27.8611 11.5645ZM42.2455 25.1531L30.1548 -2.34616C27.9015 -7.47091 21.9232 -9.79971 16.8017 -7.54792L-18.4375 7.94589L-10.7165 23.6766L2.26647 17.9683L8.12647 31.2963L-5.02498 37.0787L2.15002 53.8549L37.052 38.5094C42.1735 36.2576 44.4986 30.2776 42.2455 25.1531Z"
            fill="#090909"
          />
        </svg>
        <svg
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="27.3086"
            y="-4.31586"
            width="32"
            height="31"
            transform="rotate(66.2661 27.3086 -4.31586)"
            fill="#FADC4B"
          />
          <path
            d="M20.728 31.3354C19.0813 31.0691 17.9564 29.6092 17.9564 29.6092C17.5908 28.1692 19.0989 26.8669 21.5244 26.3934C23.9495 25.9198 26.5138 27.0149 26.8304 28.6324C27.1464 30.2501 22.3747 31.6017 20.728 31.3354ZM23.1394 22.8836C23.1378 21.1266 25.3179 19.6932 28.2586 19.425C31.0868 19.1665 33.537 20.6035 33.5386 22.3604C33.5403 24.1176 30.626 25.6708 27.786 25.6723C24.9459 25.6736 23.141 24.6405 23.1394 22.8836ZM14.2571 27.3928C12.1596 28.1138 10.1332 27.537 9.96825 24.0443C9.84664 21.4804 10.9327 21.2044 11.0137 19.558C11.0911 17.9857 8.55905 15.8058 9.7865 12.6488C11.0141 9.49199 14.6154 11.7334 16.4969 13.7247C18.3785 15.716 22.7891 16.5954 23.0993 18.6736C23.4094 20.7517 20.3947 21.6745 19.0996 22.8477C17.8047 24.0213 16.3549 26.6719 14.2571 27.3928ZM19.141 6.92538C20.7326 6.42675 25.6493 7.08359 25.5681 8.72975C25.4872 10.3758 23.1063 11.8253 20.6379 11.7028C18.1696 11.5803 16.4905 10.5066 16.6457 9.02905C16.6457 9.02905 17.5494 7.42364 19.141 6.92538ZM27.8611 11.5645C30.7008 11.5631 33.0044 12.9862 33.0063 14.743C33.0081 16.4998 30.7072 17.9254 27.8672 17.9269C25.0273 17.9287 22.7236 16.5054 22.7218 14.7486C22.7202 12.9917 25.0211 11.5661 27.8611 11.5645ZM42.2455 25.1531L30.1548 -2.34616C27.9015 -7.47091 21.9232 -9.79971 16.8017 -7.54792L-18.4375 7.94589L-10.7165 23.6766L2.26647 17.9683L8.12647 31.2963L-5.02498 37.0787L2.15002 53.8549L37.052 38.5094C42.1735 36.2576 44.4986 30.2776 42.2455 25.1531Z"
            fill="#090909"
          />
        </svg>
        <svg
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="27.3086"
            y="-4.31586"
            width="32"
            height="31"
            transform="rotate(66.2661 27.3086 -4.31586)"
            fill="#FADC4B"
          />
          <path
            d="M20.728 31.3354C19.0813 31.0691 17.9564 29.6092 17.9564 29.6092C17.5908 28.1692 19.0989 26.8669 21.5244 26.3934C23.9495 25.9198 26.5138 27.0149 26.8304 28.6324C27.1464 30.2501 22.3747 31.6017 20.728 31.3354ZM23.1394 22.8836C23.1378 21.1266 25.3179 19.6932 28.2586 19.425C31.0868 19.1665 33.537 20.6035 33.5386 22.3604C33.5403 24.1176 30.626 25.6708 27.786 25.6723C24.9459 25.6736 23.141 24.6405 23.1394 22.8836ZM14.2571 27.3928C12.1596 28.1138 10.1332 27.537 9.96825 24.0443C9.84664 21.4804 10.9327 21.2044 11.0137 19.558C11.0911 17.9857 8.55905 15.8058 9.7865 12.6488C11.0141 9.49199 14.6154 11.7334 16.4969 13.7247C18.3785 15.716 22.7891 16.5954 23.0993 18.6736C23.4094 20.7517 20.3947 21.6745 19.0996 22.8477C17.8047 24.0213 16.3549 26.6719 14.2571 27.3928ZM19.141 6.92538C20.7326 6.42675 25.6493 7.08359 25.5681 8.72975C25.4872 10.3758 23.1063 11.8253 20.6379 11.7028C18.1696 11.5803 16.4905 10.5066 16.6457 9.02905C16.6457 9.02905 17.5494 7.42364 19.141 6.92538ZM27.8611 11.5645C30.7008 11.5631 33.0044 12.9862 33.0063 14.743C33.0081 16.4998 30.7072 17.9254 27.8672 17.9269C25.0273 17.9287 22.7236 16.5054 22.7218 14.7486C22.7202 12.9917 25.0211 11.5661 27.8611 11.5645ZM42.2455 25.1531L30.1548 -2.34616C27.9015 -7.47091 21.9232 -9.79971 16.8017 -7.54792L-18.4375 7.94589L-10.7165 23.6766L2.26647 17.9683L8.12647 31.2963L-5.02498 37.0787L2.15002 53.8549L37.052 38.5094C42.1735 36.2576 44.4986 30.2776 42.2455 25.1531Z"
            fill="#090909"
          />
        </svg>
      </Wrapper>
    </AnimatedLoading>
  );
};

export default GalleryLoading;
